import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { FilterKey } from "@studyportals/search-filters";
import { SeoHeadingHandlerDefaultSorting } from "../SeoHeadingHandlerDefaultSort";

export class Continents extends SeoHeadingHandlerDefaultSorting {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return await this.selectionFor(FilterKey.CONTINENT, filterSelectionState)
			&& [1, 2].includes(this.selectionTypeCount(filterSelectionState));
	}
    
	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const singleSelectionForContinent = await this.singleSelectionFor(FilterKey.CONTINENT, filterSelectionState);

		const location = singleSelectionForContinent
			? this.getFilterOptionNameBy(FilterKey.CONTINENT, filterSelectionState)
			: "selected regions";

		const seoInfo = `Browse all universities in ${location}`;

		return Promise.resolve(seoInfo);
	}

}